import {
  isBrowser,
  isSem,
  promotingAds,
  digitalMarketingChannels,
  specialMarketingChannels,
} from "../utils";
import { tryAgl, tryAglAPI } from "./tryAgl";
export const tryNow = () => {
  tryAgl();
  // tryAglAPI();
  if (isBrowser) {
    require("sa-sdk-javascript").track("TryNow");
  }
  // 万维登录投放

  if (sessionStorage.getItem("utm_source") === "wanwei") {
    window.location.href = "https://wwads-authing.authing.cn";
  } else {
    window.location.href = urlSearch(
      "https://console.authing.cn?from_origin=authing.cn"
    );
  }
};

export const tryNowRegister = (phone) => {
  tryAgl();
  // tryAglAPI();
  if (isBrowser) {
    require("sa-sdk-javascript").track("TryNow");
  }

  let url = "https://console.authing.cn/register?from_origin=authing.cn";

  if (phone) {
    url += `&active_tab_key=phone&phone=${phone}`;
  }

  urlSearch(url);

  window.location.href = urlSearch(url);
};

const urlSearch = (url) => {
  if (isSem()) {
    url += "&sem=true";
  }

  if (promotingAds()) {
    url += `&pa=${promotingAds()}`;
  }

  if (digitalMarketingChannels()) {
    url += `&dmc=${digitalMarketingChannels()}`;
  }

  if (specialMarketingChannels()) {
    if (specialMarketingChannels() === "51cto") {
      const newUrl = new URL(url);
      newUrl.host = "51cto-users.authing.cn";
      newUrl.pathname = "/register";
      url = newUrl.toString();
    }

    url += `&smc=${specialMarketingChannels()}`;
  }
  return url;
};
